import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaShieldAlt,
  FaTag,
  FaCheckCircle,
  FaShippingFast,
} from "react-icons/fa"; // Import icons from react-icons/fa

const FeatureComponent = () => {
  const features = [
    {
      icon: FaShieldAlt,
      title: "12 Months Free Warranty",
      description: "Only for brand new mobile phones",
    },
    {
      icon: FaTag,
      title: "Best Price Guarantee",
      description: "Some of the lowest prices that you'll find",
    },
    {
      icon: FaCheckCircle,
      title: "14 Day Check Warranty",
      description: "Peace of mind & money back guarantee",
    },
    {
      icon: FaShippingFast,
      title: "Free Express Shipping",
      description: "Country Wide Free Express Shipping",
    },
  ];

  return (
    <Container>
      <Row className="justify-content-center">
        {features.map((feature, index) => (
          <Col xs={12} sm={6} md={3} key={index} className="mb-4">
            <Card className="h-100 border-0 shadow">
              <Card.Body className="text-center">
                <div className="d-flex justify-content-center mb-3">
                  <div
                    className="rounded-circle p-3"
                    style={{
                      backgroundColor: "#032a50",
                    }}
                  >
                    <feature.icon size={24} className="text-white" />{" "}
                    {/* Use the icon component directly */}
                  </div>
                </div>
                <Card.Title>{feature.title}</Card.Title>
                <Card.Text>{feature.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default FeatureComponent;
